import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/lib/auth";
import { Toaster } from "sonner";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import VerifyEmail from "@/pages/VerifyEmail";
import IdentityDocuments from "@/pages/IdentityDocuments";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Upload from "@/pages/Upload";
import Review from "@/pages/Review";
import Documents from "@/pages/Documents";
import CFPB from "@/pages/CFPBBuilder";
import Dashboard from "@/pages/Dashboard";
import Credits from "@/pages/Credits";
import Admin from "@/pages/Admin";
import ZapierGuide from "@/pages/ZapierGuide";
import LetterLibrary from "@/pages/LetterLibrary";
import AdminLetterLibrary from "@/pages/AdminLetterLibrary";
import Settings from "@/pages/Settings";

function Private({ children, adminOnly }) {
  const { user, ready } = useAuth();
  if (!ready) return <div className="min-h-screen grid place-items-center text-slate-400">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/app" replace />;
  return children;
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Toaster theme="dark" position="top-right" richColors closeButton />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/verify-email" element={<VerifyEmail />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />

          <Route path="/app" element={<Private><Dashboard /></Private>} />
          <Route path="/app/upload" element={<Private><Upload /></Private>} />
          <Route path="/app/review/:id" element={<Private><Review /></Private>} />
          <Route path="/app/documents" element={<Private><Documents /></Private>} />
          <Route path="/app/identity" element={<Private><IdentityDocuments /></Private>} />
          <Route path="/app/cfpb" element={<Private><CFPB /></Private>} />
          <Route path="/app/credits" element={<Private><Credits /></Private>} />
          <Route path="/app/settings" element={<Private><Settings /></Private>} />
          <Route path="/app/admin" element={<Private adminOnly><Admin /></Private>} />
          <Route path="/app/admin/zapier-guide" element={<Private adminOnly><ZapierGuide /></Private>} />
          <Route path="/app/letters" element={<Private><LetterLibrary /></Private>} />
          <Route path="/app/admin/letter-library" element={<Private adminOnly><AdminLetterLibrary /></Private>} />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
